const TeammatemeIcon = () => (
  <img
    className="img--footer_social_icon"
    src={`/svg/teammateme.svg`}
    alt="teammateme"
  />
);

export default TeammatemeIcon;
